class Auth {
  constructor() {
    this.authenticated = false;
  }

  login(cb) {
    this.authenticated = true;
    cb();
  }

  logout(cb) {
    this.authenticated = false;
    cb();
  }

  isAuthenticated() {
    // fetch(process.env.REACT_APP_API_URL+'api/user/auth')
    // .then(response => response.json())
    // .then(data => {
    //   if(data.issuccessful == true){
    //     return true;
        
    //   }
    //   else{
    //     return false;
    //   }
    //});
    if(localStorage.getItem('pats_login') === null){
      return false
    }
    else{
      return true
    }
    
    
    //return this.authenticated;
  }
}

export default new Auth();
